import React, { useMemo, useState } from "react";
import { Button, OverlayTrigger, Tooltip, Image } from 'react-bootstrap';
import { CalendlyPop, GET_NETWORK_ICON, baseUrl, parseNumber } from "../../../../../utils";
import { FontAwesomeIcon } from "../../../../CommonComponents/AssetsHelper";

function PricingTabDisplay({ isPlanActive, onClickToNavigate, planChecked, handleCheckout, userData, plan }) {
    const [loading, setLoading] = useState(false);
    const { day, desc, listFeatureList, planId, planName, planPrice, planMonthlyDataProductID, planYearlyDataProductID, planYearlyPrice, diffrenceYearlyPrice, diffrencePrice } = plan;
    const [talkshow, talksetShow] = useState(false);
    const isNewUser = userData?.user?.id>182315
  
    const { HL_PLAN, customUser, currentPrice, priceDifference, btnMsg, btnActive } = useMemo(() => {
        const HL_PLAN = planName === "ENGAGE";
        const customUser = localStorage.getItem('ownerId') === '143905';
  
        const userBillingCycle = userData?.user?.planBillingCycle ?? null;
        const userPlanId = userData?.UserPlan?.planId ?? "";

        const isActive = isPlanActive ? isPlanActive(planId) : false;
        const isYearly = Boolean(userBillingCycle);

        const currentPrice = parseNumber(planChecked ? planYearlyPrice : planPrice);
        const priceDifference = parseNumber(planChecked ? diffrenceYearlyPrice : diffrencePrice);

        let btnType = 0;
        if (planId === "58" && String(userPlanId).includes("58")) btnType = 1;
        else if (isActive) btnType = isYearly ? 1 : (planChecked ? 2 : 1);

        let btnMsg = "Select Plan";
        if (!planId) btnMsg = "Talk To Sales";
        else if (btnType === 1) btnMsg = "Current Plan";
        else if (btnType === 2) btnMsg = "Switch Yearly (Save Upto 25%)";
        else if (priceDifference) btnMsg = "Upgrade Now";

        const btnActive = btnType !== 1;

        return { HL_PLAN, customUser, currentPrice, priceDifference, btnMsg, btnActive };
    }, [planName, planChecked, planId, planPrice, planYearlyPrice, diffrencePrice, diffrenceYearlyPrice, userData]);

    return <div className={`price_counter price_card_wrap price_meter ${HL_PLAN ? "highlightCard" : ""}`} key={planId}>
        <div className="price_card">
            <h3 className="color1 text-uppercase">{planName}</h3>
            <div className="price_card_inner">
                <p className="color2 f2">{desc}</p>

               { !isNewUser ? 
                <div className="price_wrap">
                    {planPrice === 0 || planPrice === "" ? (
                        <h2 className={HL_PLAN ? "colorActive" : "color1"}>
                            <span className="price count">{planPrice === 0 ? "FREE" : day}</span>
                        </h2>
                    ) : (
                        <h2 className={HL_PLAN ? "colorActive" : "color1"}>
                                {priceDifference ? <span className="just-pay-wrap d-flex align-items-center justify-content-between">
                                    <span className="just-play-left d-flex align-items-center">
                                        <span className="just-pay">Just Pay</span>
                                        <sup>$</sup><span className="price odometer count">{priceDifference}</span>
                                        <span className={`valid_from color2`}>More</span>
                                    </span>
                                    <span className="just-play-right d-flex align-items-center">
                                        <span className="line-through"><sup>$</sup><span className="price odometer count">{currentPrice}/</span></span>
                                        <span className={`valid_from color2`}>{day}</span>
                                    </span>
                                </span> : <><sup>$</sup>
                                    <span className="price odometer count" data-price-monthly={planPrice} data-price-yearly={parseInt(planYearlyPrice)} data-product-monthly={planMonthlyDataProductID} data-product-yearly={planYearlyDataProductID}>
                                        {customUser ? (planChecked ? planName == "ENGAGE" ? '159' : '79' : planName == "ENGAGE" ? '199' : '99') : (currentPrice)}
                                    </span>
                                    <span className={`valid_from color2 ${HL_PLAN ? "colorActive" : ""}`}>/{day}</span></>}
                        </h2>
                    )}
                </div> : 
                  <>
                   {talkshow ? <CalendlyPop show={talkshow} hidePop={()=>talksetShow(false)} url={'https://calendly.com/taggbox/demo?embed_domain=app.socialwalls.com&embed_type=PopupText'} /> : null}
                    <div className="price_btn">
                        <Button variant={!btnActive ? 'primary ' : 'outline-dark'} disabled={!btnActive} id={`tb_${String(planName).toLocaleLowerCase()}`} name="planName" 
                        value={planId} data-price={planPrice} className={`btn-hover-primary w-100 ${loading ? 'spinner spinner-right disabled' : ''} ${customUser && planId != "" ? 'disabled' : ''}`} 
                    onClick={btnActive ? planId == "" ? () => talksetShow(true) : () => talksetShow(true) : null}  style={{ marginTop : 0}}>{btnMsg=='Current Plan' ? btnMsg : 'Talk To Sales'}</Button>
                    </div>
                </>
              }

                <ul className="pricingList">
                    {listFeatureList &&
                        listFeatureList.map((feature, index) => {
                            const { name, value, description, networkList } = feature;
                            return (
                                <OverlayTrigger key={index} placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip className={networkList.length <= 0 ? 'dark' : 'light'}>
                                    {networkList.length <= 0 ? description
                                        : <ul className="platform__icons colored_social_icons">
                                            {networkList.map(({ name, id }) => (
                                                <li key={id}>
                                                    <Image alt={name} src={baseUrl(`icons/social-icons/${GET_NETWORK_ICON(id)}.svg`)} height="16" width="16" />
                                                </li>
                                            ))}
                                        </ul>}
                                </Tooltip>}>
                                    <li>
                                        <span className="iconCheckClose">
                                            <FontAwesomeIcon type={'solid'} icon={`circle-${value === 1 ? "check" : "xmark"}`} iconClass={`text-${value === 1 ? "success" : "danger"}`} />
                                        </span>
                                        {name} <FontAwesomeIcon type={'regular'} icon={'circle-info'} iconClass={'fs-6 text-gray-500'} /> {['AI Recommendation', 'Auto Pilot', 'Reactions'].includes(name) && <span className="new-tag">New</span>}
                                    </li>
                                </OverlayTrigger>
                            );
                        })}
                </ul>
                { !isNewUser ? <div className="price_btn">
                    <Button variant={!btnActive ? 'primary ' : 'outline-dark'} disabled={!btnActive} id={`tb_${String(planName).toLocaleLowerCase()}`} name="planName" value={planId} data-price={planPrice} className={`btn-hover-primary w-100 ${loading ? 'spinner spinner-right disabled' : ''} ${customUser && planId != "" ? 'disabled' : ''}`} onClick={btnActive ? planId == "" ? onClickToNavigate : () => { setLoading(true); handleCheckout(() => setLoading(false)) } : null}>{btnMsg}</Button>
                </div> : null }
            </div>
        </div>
    </div>
}

export default PricingTabDisplay;